import { useAmenitiesIcons } from 'legacyfrontend/hooks/packages';
import commons from 'legacyfrontend/components/commons';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';

export default function Banner({ data, className }) {
  const [getIcon] = useAmenitiesIcons();
  const { getNavigationProps } = useBannerNavigation();
  
  const {
    title,
    description,
    price,
    manualPrice,
    services,
    tag,
    descuento,
    mostrarTitulo,
    mostrarDescripcion,
    mostrarPrecio,
    mostrarDescuento,
    mostrarExtra,
  } = data;

  
  const biyu = price === null ? manualPrice : price;
  const desktopImg = commons.imgUrlValidator(data.imageUrl);
  const mobileImg = commons.imgUrlValidator(data.imagenMobile || data.imageUrl);
  const navigationProps = getNavigationProps(data);

  const renderAmenitiesIcons =
    services &&
    services.map((serviceKeyName) => (
      <span key={`${title}-service-${serviceKeyName}`} className='mr-2'>
        <i className={getIcon(serviceKeyName)} />
      </span>
    ));

  const hasTextContent = (!mostrarTitulo && title) || (!mostrarDescripcion && description);
  const hasPriceContent = !mostrarPrecio && biyu;
  const hasAmenitiesContent = !mostrarExtra && renderAmenitiesIcons;
  const hasTagContent = (!mostrarExtra && tag?.trim()) || 
                       (!mostrarPrecio && manualPrice?.trim()) || 
                       (!mostrarDescuento && descuento?.trim());
  
  const hasContent = hasTextContent || hasPriceContent || hasAmenitiesContent || hasTagContent;


  return (
    <div id={data.id} className={`${className ?? ''} banner-container no-video ${hasContent ? 'flex flex-col' : ''}`}>
      <a
        href={navigationProps.href}
        target={navigationProps.target}
        rel='noreferrer'
        className={hasContent ? 'flex flex-col h-full' : 'block'}
      >
        <div className={`banner-image-container min-h-[150px] ${hasContent ? 'flex-1' : ''} relative`}>
          <picture>
            <source media='(max-width: 768px)' srcSet={mobileImg} />
            <img
              className={`banner-image ${hasContent ? 'w-full h-full object-cover' : 'w-full h-auto'}`}
              src={desktopImg}
              alt={title}
              loading='lazy'
            />
          </picture>
          {hasTagContent && (
            <div className='banner_tag-amenities'>
              {!mostrarExtra && tag?.trim() && (
                <div className='banner_tag'>{tag}</div>
              )}
              {!mostrarPrecio && manualPrice?.trim() && (
                <div className='banner_tag_price'>{manualPrice}</div>
              )}
              {!mostrarDescuento && descuento?.trim() && (
                <div className='banner_discount'>{descuento}</div>
              )}
            </div>
          )}
        </div>
        {hasContent && (
          <div className='banner-content flex-shrink-0'>
            {hasTextContent && (
              <div className='flex justify-between items-center p-3'>
                <div className='text-information'>
                  {!mostrarTitulo && title && (
                    <div className='banner_info-title'>{title}</div>
                  )}
                  {!mostrarDescripcion && description && (
                    <div className='banner_info-description'>{description}</div>
                  )}
                </div>
              </div>
            )}
            {hasPriceContent && (
              <div className='banner-price'>
                <span className='price-text'>{biyu}</span>
              </div>
            )}
            {hasAmenitiesContent && (
              <div className='banner-amenities'>{renderAmenitiesIcons}</div>
            )}
          </div>
        )}
      </a>
    </div>
  );
}
